import type { ReactNode } from 'react';

export const symbol_exposure_plus_1: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M250-410H150q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h100v-100q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v100h100q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H310v100q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-100Zm400-257-72 52q-11 8-24 5t-20.89-14.38Q526-635 528-647q2-12 13-20l121-88q3-2 6.75-3.5t7.92-1.5H695q10.94 0 17.97 7.03Q720-745.94 720-735v500q0 14-10.5 24.5T685-200q-14 0-24.5-10.5T650-235v-432Z"
		/>
	</svg>
);
